import React from 'react'

export default function Attendance({ data }) {
    
    if (!data) {
        return (
            <div className=" relative mt-2 h-10 overflow-hidden rounded-lg bg-slate-50 w-full">
                <div className="skeleton">
                </div>
            </div>
        )
    }
    if (!data.auth) {
        return (
            <div className="relative mt-2 overflow-hidden rounded-lg bg-slate-50 w-full flex items-center px-3 py-2 justify-between">
                <div className="flex items-center gap-2">
                    <img src="/img/navicons/attendance.svg" alt="avatar" className="w-8 h-8 opacity-60" />
                    <div>
                        <h5 class="text-xs font-semibold tracking-tight text-gray-700">Checkout Attendance Calculator</h5>
                        <p class="font-normal text-gray-500 text-[10px] pr-3">Go to this step by step guideline process on how to certify for your weekly benefits:</p>
                    </div>
                </div>
                <a type="button" class="text-white bg-blue-600 hover:bg-blue-700  focus:bg-blue-900 font-medium rounded-md text-[10px] px-1 py-1 w-32 text-center">Check Now</a>
            </div>
        )
    }
}
